export class Agent {
    readonly sid: string = '';
    readonly full_name?: string = ''
    readonly phone?: string = ''
    readonly contact_uri: string = ''
    readonly email?: string = ''
    readonly categories?: number[] = []
    readonly skills?: string[] = []
    readonly roles: string[] = []  
}